import { ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MainService } from './../Services/service.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-buy-baner',
  templateUrl: './buy-baner.component.html',
  styleUrls: ['./buy-baner.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BuyBanerComponent implements OnInit {

  constructor(public service: MainService, private route: ActivatedRoute) { }

  ngOnInit(){
    this.service.hideLoader(true);
  }

  onTokenAdded(response) {
    if (response.isError) {
      this.service.showError(response.message ? response.message : "Payment process error.");
    } else {
      this.service.showInformation('Your banner ad has been added for the next month.');
      setTimeout(()=>{ this.service.route.navigate(["/"]); }, 2000);
    }
  }

}
